<template>
  <div class="hello">
    <nnav></nnav>
    <div class="bgimg">
      <div class="userlist" style="overflow: visible;">
        <div class="list_head">
          <div
            class="topTitle"
            style="margin-left: 40px;padding: 8px 20px 13px !important;"
          >
            <img
              style="margin-right: 8px;"
              src="../../assets/images/dh111.png"
              alt=""
            />
            <span style="font-size: 14px;color: #2C2F37;">帮助</span
            ><span style="color: #868E99;font-size: 14px;"
              >&nbsp;>&nbsp;意见反馈</span
            >
          </div>
          <div class="text_box" :style="{ minHeight: MHeight }">
            <p class="top_text">尊敬的用户：</p>
            <p class="top_text">
              您好，为了给您提供更好的服务，我们希望收集您使用 交易客户端
              时的看法或建议。对您的配合和支持表示衷心的感谢！
            </p>
            <div class="box_body">
              <div class="box-header">
                如果您在使用交易客户端时，想对我们的产品提出意见或建议，请在下方填写。我们会持续关注您的反馈，不断优化产品，为您提供更好的服务！
              </div>
              <div class="box_RichText">
                <quill-editor
                  ref="text"
                  v-model="content"
                  class="myQuillEditor"
                  :options="editorOption"
                />
              </div>
            </div>

            <div class="box_body">
              <div class="box-header">
                如果方便的话，请留下您的联系方式，方便我们在收到反馈之后第一时间与您进行联系！
              </div>
              <div class="input_box">
                <label for="">
                  <span>邮箱</span>
                  <el-input
                    v-model="email"
                    placeholder="请输入您的邮箱"
                  ></el-input>
                </label>
                <label for="">
                  <span>手机号</span>
                  <el-input
                    v-model="phone"
                    placeholder="请输入您的手机号"
                  ></el-input>
                </label>
              </div>
            </div>
            <div class="btn" style="margin-top: 50px;">
              <div class="button" @click="submit">提交</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nnav from '../../components/nav/index';
import './style.css';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  components: { nnav, quillEditor },
  name: 'feedback',
  data() {
    return {
      content: '',
      editorOption: {},
      email: '',
      phone: '',
      MHeight: document.documentElement.clientHeight - 160 + 'px',
    };
  },
  methods: {
    submit() {
      //提交建议
      // console.log(this.$refs.text.value);
      if (this.content) {
        this.$axios
          .post('/cloud/ctp_user/feedback', {
            apiToken: this.$store.state.usermsg.apiToken,
            content: this.content,
            email: this.email,
            phone: this.phone,
          })
          .then((res) => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$alert(
                '提交成功，非常感谢您的支持与配合。我们将密切关注您的反馈，不断优化产品，为您提供更好的服务!',
                {
                  confirmButtonText: '确定',
                  center: true,
                  callback: (action) => {
                    window.location.reload();
                  },
                  type: 'success',
                }
              )
                .then(() => {})
                .catch(() => {});
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                center: true,
                type: 'error',
              })
                .then(() => {})
                .catch(() => {});
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      } else {
        this.$alert('请填写反馈意见', {
          confirmButtonText: '确定',
          center: true,
          type: 'error',
        })
          .then(() => {})
          .catch(() => {});
      }
    },
  },
};
</script>
<style>
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
  content: '10px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
  content: '18px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
  content: '标题1';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
  content: '标题2';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
  content: '标题3';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
  content: '标题4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
  content: '标题5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
  content: '衬线字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
  content: '等宽字体';
}
.ql-editor.ql-blank:before {
  content: '';
}
</style>



// WEBPACK FOOTER //
// src/view/feedback/index.vue